import { __decorate } from "tslib";
import Component from 'vue-class-component';
import SimpleCrud from '@/components/SimpleCrud.vue';
import Vue from 'vue';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { INPUT_TYPES } from '@/constants/InputTypes';
import { getLastConcludedWorkDate } from '@/utils/effectiveDateValidation';
import moment from 'moment';
let Grades = class Grades extends Vue {
    lastConcludedDate = null;
    title = 'Platové třídy';
    storeModule = 'grade';
    formAddTitle = 'Nová platová třída';
    formEditTitle = 'Upravit platovou třídu';
    headers = [
        {
            text: 'Platová třída',
            value: 'data.title',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.TEXT,
        },
        {
            text: 'Individuální výuka (Kč/h)',
            value: 'data.individual',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.UNSIGNED_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
            customPrint: value => value + ',- Kč',
        },
        {
            text: 'WEX (Kč/h)',
            value: 'data.wex',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.UNSIGNED_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
            customPrint: value => value + ',- Kč',
        },
        {
            text: 'Dětská školka (Kč/h)',
            value: 'data.kidSchool',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.UNSIGNED_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
            customPrint: value => value + ',- Kč',
        },
        {
            text: 'Storno (Kč/h)',
            value: 'data.storno',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.UNSIGNED_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
            customPrint: value => value + ',- Kč',
        },
        {
            text: 'Platnost od',
            value: 'data.effectiveDate',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.VALID_DATE],
            type: INPUT_TYPES.DATE,
            customPrint: (value) => {
                if (!value)
                    return '';
                const m = moment(value);
                return m.isValid() ? m.format('DD.MM.YYYY') : '';
            },
        },
        {
            text: '',
            value: 'actions',
            rules: [],
            type: '',
            sortable: false,
            notEditable: true,
        },
    ];
    defaultItem = {
        id: 'new-grade',
        data: {
            title: '',
            individual: 0,
            wex: 0,
            kidSchool: 0,
            storno: 0,
            effectiveDate: moment().format('YYYY-MM-DD'),
            deletedAt: null,
        },
    };
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    async mounted() {
        this.lastConcludedDate = await getLastConcludedWorkDate();
    }
    /**
     * Determines if a grade record can be edited.
     * Records with effectiveDate on or before the last concluded work date are immutable.
     * Legacy records without effectiveDate are treated as epoch date (1970-01-01) and are read-only.
     *
     * @param item - The grade record to check
     * @returns true if the item can be edited, false otherwise
     */
    canEditItem(item) {
        if (!this.lastConcludedDate) {
            // No concluded work exists, all items can be edited
            return true;
        }
        // Treat missing effectiveDate as epoch (1970-01-01) - legacy data is read-only
        const effectiveDate = item.data.effectiveDate || '1970-01-01';
        // Can only edit if effectiveDate is strictly AFTER last concluded date
        return effectiveDate > this.lastConcludedDate;
    }
    /**
     * Determines if a grade record is superseded by another record with the same title
     * but a newer effectiveDate that is already in effect (effectiveDate <= today).
     *
     * @param item - The grade record to check
     * @returns true if the item is superseded, false otherwise
     */
    isGradeSuperseded(item) {
        if (!item.data?.effectiveDate)
            return false;
        const today = moment().format('YYYY-MM-DD');
        // Find if there's another active (non-deleted) grade with same title and newer effectiveDate
        const items = this.$store.getters['grade/all'];
        return items.some((other) => {
            if (other.id === item.id)
                return false;
            if (other.data?.deletedAt)
                return false;
            if (other.data?.title !== item.data?.title)
                return false;
            const otherDate = other.data?.effectiveDate || '1970-01-01';
            const itemDate = item.data?.effectiveDate || '1970-01-01';
            // Other must be newer AND still valid (effectiveDate <= today)
            return otherDate > itemDate && otherDate <= today;
        });
    }
};
Grades = __decorate([
    Component({
        components: {
            SimpleCrud,
        },
    })
], Grades);
export default Grades;
